module.exports = __webpack_public_path__ + "media/fonts/Oricons-5aa0d0929db316bb9845299ed21a23eb.woff";